import effectManager from '../effect';
import Param from '../../param';

const param = new Param();
const effect = new effectManager();

export default class globalNavi{
    constructor(){

        /* 必要なDOM */
        this.header = $("#l-header");
        this.$trigger = $("#l-header__inner");
        this.$logo =  $("#l-header-logo-white");
        this.$logoColor =  $("#l-header-logo-color");
        this.$triggerIcon = $("#l-header-trigger");
        this.$share = $("#l-header-share");

        this.$bg = $("#l-header-navi-bg >.l-bg");
        this.$bgImg = $("#l-header-navi-bg-image >*");

        this.$navi = $("#l-header-navi");
        this.$naviLink = $("#l-header-navi-content >* >*");

        /* 設定 */
        this.conf = {
        }

        /* ステータス */
        this.status = {
            now : "close",
            motion : false,
            device : "pc",
            current : "",
        }


    }
    init() {

        let _this = this;

        /* 必要なDOM */
        this.header = $("#l-header");
        this.$trigger = $("#l-header__inner");
        this.$logo =  $("#l-header-logo-white");
        this.$logoColor =  $("#l-header-logo-color");
        this.$triggerIcon = $("#l-header-trigger");
        this.$share = $("#l-header-share");

        this.$bg = $("#l-header-navi-bg >.l-bg");
        this.$bgImg = $("#l-header-navi-bg-image >*");

        this.$navi = $("#l-header-navi");
        this.$naviLink = $("#l-header-navi-content >* >*");

        /* ステータス */
        this.status = {
            now : "close",
            motion : false,
            device : "pc",
            current : "",
        }
        
        effect.show($(".js__navi-show"),"set");
        effect.bg(this.$bg,"set");
        effect.bgImg(this.$bgImg,"set");


        /* グロナビ開閉用 */
        this.$trigger.on("mouseenter",function () {

            _this.mouseOn($(this));

        }).on("mouseleave",function () {

            _this.mouseOut($(this));

        });

        this.$trigger.on("click",function () {


            if(_this.status.motion) return;
            _this.status.motion = true;

            if(_this.status.now==="close"){
                _this.naviOpen($(this));
            }else{
                _this.naviClose($(this));
                _this.mouseOut($(this));
            }

            setTimeout(function () {
                _this.status.motion = false;
            },1e3);

        });


        /* グロナビ内のリンク */
        // effect.bgImg(this.$bgImg,"show");
        this.$naviLink.on("mouseenter",function () {

            if(param.displayType === 'sp'||Useragnt.tablet) return;
            _this.status.current = $(this).data("target");
            $("#l-header-navi-bg-image-"+_this.status.current).addClass("is-active");
            effect.bgImg($("#l-header-navi-bg-image-"+_this.status.current),"show");

        }).on("mouseleave",function () {
            if(param.displayType === 'sp'||Useragnt.tablet) return;
            _this.$bgImg.removeClass("is-active");
            effect.bgImg(_this.$bgImg.not(".is-active"),"out");

        });
        this.$naviLink.on("click",function() {
            if(_this.status.motion || $(this)[0]['localName'] === 'a' || $(this)[0].classList.contains('js__modal-trigger')) return;
            _this.status.motion = true;
            _this.naviClose(_this.$trigger);
            setTimeout(function () {
                _this.status.motion = false;
            },1e3);
        });
    }
    naviOpen($this){
        this.status.now = "open";
        TweenMax.set(this.$navi,{opacity:1})
        effect.show($(".js__navi-show"),"show");
        effect.bg(this.$bg,"show");
        $this.addClass("is-open");
        this.$navi.addClass("is-open");
        this.header.addClass("is-open");
        setTimeout(()=> this.$navi.addClass("is-color"),5e2)
        TweenMax.to(this.$logo,0.4,{
            "opacity":1
        });
        TweenMax.to(this.$logoColor,0.4,{
            "opacity":0
        });
    }
    naviClose($this){
        this.status.now = "close";
        effect.show($(".js__navi-show"),"out");
        TweenMax.killTweensOf(this.$bg)
        effect.bg(this.$bg,"out");
        this.$trigger.removeClass("is-open");
        setTimeout(()=> $this.removeClass("is-open").removeClass("is-color"),5e2)
        this.$navi.removeClass("is-open");
        this.header.removeClass("is-open");
        TweenMax.to(this.$navi,0.6,{opacity:0,delay:1.2})
        TweenMax.to(this.$logo,0.4,{
            "opacity":0
        });
        TweenMax.to(this.$logoColor,0.4,{
            "opacity":1
        });
    }
    mouseOn($this){
        TweenMax.killTweensOf($this);
        TweenMax.to($this,0.4,{
            "backgroundColor":param.conf.keycolor
        });
        TweenMax.to(this.$triggerIcon.children().children(),0.4,{
            "backgroundColor":"#fff"
        });
        if(this.status.now === 'open') return;
        TweenMax.to(this.$logo,0.4,{
            "opacity":1
        });
        TweenMax.to(this.$logoColor,0.4,{
            "opacity":0
        });
    }
    mouseOut($this){
        TweenMax.killTweensOf($this);
        TweenMax.to($this,0.4,{
            "backgroundColor":"#fff"
        });
        TweenMax.to(this.$triggerIcon.children().children(),0.4,{
            "backgroundColor":param.conf.keycolor
        });
        if(this.status.now === 'open') return;
        TweenMax.to(this.$logo,0.4,{
            "opacity":0
        });
        TweenMax.to(this.$logoColor,0.4,{
            "opacity":1
        });
    }
    motion(mode){



    }

    resize(){
        let _w = window.innerWidth;
        if(_w>param.breakpoint){
            if(this.status.device==="sp") this.set("pc");
            this.status.device = "pc";
        }else{
            if(this.status.device==="pc") this.set("sp");
            this.status.device = "sp";
        }
    }
}